var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1213 20.0296H16.2137V17.1683H13.3524V15.2607H16.2137V12.3994H18.1213V15.2607H20.9826V17.1683H18.1213V20.0296ZM11.4449 17.1683H1.90723V15.2607H11.4449V17.1683ZM14.3062 13.3532H1.90723V11.4457H14.3062V13.3532ZM14.3062 9.53812H1.90723V7.63058H14.3062V9.53812Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMusic);
export default __webpack_public_path__ + "static/media/add-music.8e5513fc386613e0957cefb80b6babe8.svg";
export { ForwardRef as ReactComponent };